export default {
    API_URL: process.env.NODE_ENV === 'production' ? "https://api.retenlo.com.ve/" : "http://retenciones.app/",
    ADM_URL: process.env.NODE_ENV === 'production' ? "https://retenlo.com.ve/" : "http://retencionesadmin.app/",
    UND_TRIBUTARIA: 177.00,

};



/** WEBPACK FOOTER **
 ** ./app-react/env.js
 **/